// extracted by mini-css-extract-plugin
module.exports = {"content":"storypage_content__V0nMT"};